import { InjectionToken } from '@angular/core';
export const LOCAL_STORAGE_TEST_SCHEDULER = new InjectionToken('LocalStorageTestScheduler');
